<template>
  <div class="flex-row-h-center business-license">
    <div class="left">
      <img style="width: 120px;" src="@/assets/apply/business-license.png" alt="">
    </div>
    <div class="right">
      <p>1.照片方向正确，不能颠倒</p>
      <p>2.需文字清晰，边框完整、露出国微</p>
      <p>3.请上传原件或复印件的扫描件，如上传复印件，需加盖公章</p>
      <p>4.具备相关公司资质(网络技术公司、文化传媒公司等)</p>
      <p>5.属于网络表演经纪机构的MCN机构需要上传《营业性演出许可证》</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "business-license"
}
</script>

<style lang="scss" scoped>
.business-license {

  .left {
    width: 120px;
  }

  .right {
    flex: 1;
    padding-left: 20px;
  }
}
</style>